<template>
  <v-dialog v-model="dialog" max-width="290">
    <v-card>
      <v-card-title class="headline">{{ labels.reminder }}</v-card-title>

      <v-card-text>{{ labels.message1 }}</v-card-text>
      <v-card-text>{{ labels.message2 }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" flat="flat" @click="dialog = false">{{
          labels.confirm
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import languages from "../languages/Dialog.json";

export default {
  data: () => ({
    labels: {
      reminder: "",
      message1: "",
      message2: "",
      confirm: "",
    },
    dialog: true,
  }),
  computed: {
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
      this.dialog = true;
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    setLanguage: function (select_language) {
      this.labels.reminder = languages.reminder[select_language.lang];
      this.labels.message1 = languages.message1[select_language.lang];
      this.labels.message2 = languages.message2[select_language.lang];
      this.labels.confirm = languages.confirm[select_language.lang];
    },
  },
};
</script>
